import store from '../../../../store/index'
import EventBus from '../../../../event-bus'
export function setLastPriceForMaterialManufacturing(manufacturing_entry, header){
    if(header === 'material_id' && manufacturing_entry.material_id) {
        store.dispatch("materials/fetchLastPurchasePrice", manufacturing_entry.material_id)
        .then(response => {
            manufacturing_entry.cost = { amount: response, currency_id: null };
            if(manufacturing_entry['quantity.quantity']){
                const totalCostAmount = manufacturing_entry.cost?.amount * manufacturing_entry['quantity.quantity']
                manufacturing_entry.total_cost = { amount: totalCostAmount, currency_id: null };
            }
        })
    }
}

export function updateCalculated(invoiceEntry, header) {
    // في حال تغيير المستودع 
    // -- في حال وجود مادة سيتم حذف المادة
    // ---سيتم قدح حدث لتحديث قوائم المواد بناءً على المستودع المُختار
    // ---في حال لم يتم تعيين مستودع سيتم عرض جميع مواد الملف المالي
    if(header === 'warehouse_id')
    {
        EventBus.$emit('warehouse-changed', invoiceEntry.warehouse_id)
    }
    // في حال تعيين مادة وما من مستودع مُختار سيتم تعيين المستودع التابع للمادة
    if(header === 'material_id')
    {
        if(!invoiceEntry.warehouse_id && invoiceEntry.material_id)
            EventBus.$emit('warehouse-changed', null, invoiceEntry.material_id)
    }
    // في حال تغيير الكمية أو السعر
    // -- تحديث عمود القيمة 
    // -- تعديل قيمة الحسم
    if((header === 'quantity.quantity' && (invoiceEntry.cost?.amount?? false)) || (header === 'cost' && invoiceEntry['quantity.quantity'])){
        const totalCostAmount = invoiceEntry.cost?.amount * invoiceEntry['quantity.quantity']
        invoiceEntry.total_cost = { amount: totalCostAmount, currency_id: null };
    }
}